<template>
  <b-tooltip
      v-if="!allowed"
      :label="effectiveReason"
      position="is-top"
      type="is-dark"
      :delay="200"
  >
    <b-button
        v-bind="$attrs"
        disabled
        class="omx-permbtn omx-permbtn--locked"
        @click="onLockedClick"
    >
      <slot />
    </b-button>
  </b-tooltip>
  <b-button
      v-else
      v-bind="$attrs"
      v-on="$listeners"
      class="omx-permbtn"
  >
    <slot />
  </b-button>
</template>

<script>
/**
 * OmxPermissionButton — replaces the "hide silently if not allowed" pattern.
 *
 *   <OmxPermissionButton
 *       :allowed="currentUserAccess('ProjectDetails', UserActions.UPDATE, projectId)"
 *       :reason="$t('permissions.requires-pm')"
 *       type="is-primary"
 *       icon-left="pencil"
 *       @click="editClicked"
 *   >{{ $t('common.edit') }}</OmxPermissionButton>
 *
 * Renders the button disabled-with-tooltip when permission is denied, so the
 * UI doesn't suddenly grow an empty space (which is confusing) and the user
 * can see *why* the action is unavailable.
 */
export default {
  name: "OmxPermissionButton",
  inheritAttrs: false,
  props: {
    allowed: { type: Boolean, required: true },
    reason:  { type: String, default: null }
  },
  computed: {
    effectiveReason() {
      return this.reason || (this.$t && this.$t('common.no-permission')) || "You don't have permission for this action";
    }
  },
  methods: {
    onLockedClick(e) {
      // Swallow the click so listeners attached upstream don't fire on disabled state.
      e.stopPropagation();
      e.preventDefault();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.omx-permbtn--locked {
  opacity: .55;
  cursor: not-allowed !important;
}
</style>
